<template>
  <nav class="menu" :class="[{'menu--is-active': isOpen}]">
    <ul>
      <li
      v-for="(item, n) in links"
      class="menu-list-entry"
      :key="n">
        <router-link
          v-click-ui-close
          class="menu-list-entry__link"
          :class="{'menu-list-entry__link--is-active': item.route.name === activeView || false}"
          v-click-route-match="{route: currentRoute}"
          :to="item.route">
          {{item.text}}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ModuleAppMenu',
  data () {
    return {
      links: [
        { route: { name: 'ViewHome' }, text: 'Start' },
        { route: { name: 'ViewAboutUs' }, text: 'Om oss' },
        { route: { name: 'ViewTheYear' }, text: 'Renens år' },
        { route: { name: 'ViewOrder' }, text: 'Beställning' }
      ],
      currentRoute: null
    }
  },
  computed: {
    activeView: function () {
      return this.$route.name
    },
    ...mapGetters({
      isOpen: 'menu/isOpen'
    })
  },
  mounted () {
    this.currentRoute = this.$route.path
  },
  watch: {
    '$route' (to, from) {
      this.currentRoute = this.$route.path
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "./app-menu";
</style>



// WEBPACK FOOTER //
// src/modules/ModuleAppMenu/ModuleAppMenu.vue